__turbopack_context__.v({
  "gruppe": "AttributtListe-module__9ilEyW__gruppe",
  "ikkeValgt": "AttributtListe-module__9ilEyW__ikkeValgt",
  "label": "AttributtListe-module__9ilEyW__label",
  "liste": "AttributtListe-module__9ilEyW__liste",
  "rad": "AttributtListe-module__9ilEyW__rad",
  "verdi": "AttributtListe-module__9ilEyW__verdi",
});
